import { useSelector } from 'react-redux'
import { ReactComponent as MiniDivisionBadge } from '../../../../assets/images/common/icons/mini-division-badge.svg'
import { ReactComponent as HorizontalLogo } from '../../../../assets/images/logos/horizontal-logo.svg'
import { DATETIME_FORMAT, getMomentInCommunityTimezoneReversed } from '../../../../utility/datesHelper'
import { splitArray } from '../../../../utility/arrayHelper'
import { levelColors } from '../../../../utility/curriculumHelper'
import moment from 'moment'

import classes from './CartSigns.module.scss'
import classNames from 'classnames'

const CartSigns = () => {
  const timezone = useSelector(state => state.user.current_user.communities[0].timezone)
  const event = useSelector(state => state.nineHoleEvent)
  const community = useSelector(state => state.user.current_user.communities[0])
  const timestamp = new Date().getTime()

  let groupedPairingGroups = event.pairings.pairingGroups.flatMap(group => {
    const groups = []
    for (let i = 0; i < group.users.length; i += 2) {
      groups.push ({
        ...group,
        users: group.users.slice(i, i + 2),
      })
    }
    return groups
  })



  groupedPairingGroups = splitArray(groupedPairingGroups, 2)

  return (
    <div id='cartSigns' className={classes.cartSigns}>
      {groupedPairingGroups.map((pairingGroups, pageIndex) =>
        <div key={pageIndex} className={classNames('CartSignsPage', classes.cartSignsPage)}>
          {pairingGroups.map((group, index) => (
            <div className={classes.cartSign} key={index}>
              <div className='d-flex justify-content-between align-items-center mb-4'>
                <div className='d-flex align-items-center'>
                  <div className={classNames('round-image-wrapper', classes.communityLogo)}>
                    <img
                      className='round-image'
                      src={`${community.photo?.file_url}${timestamp}`}
                      alt={community.name}
                      crossOrigin='anonymous'
                    />
                  </div>
                  <p className={classNames('mb-0', classes.communityName)}>{community.name}</p>
                </div>
                <HorizontalLogo className={classes.op36Logo}/>
              </div>

              <div className='d-flex justify-content-between px-2'>
                <p className={classNames('mb-1', classes.startTime)}>
                  Time:
                  <span className='pl-4'>
                    {getMomentInCommunityTimezoneReversed(moment(group.startTime), timezone, DATETIME_FORMAT).format('LT')}
                  </span>
                </p>
                <p>
                Hole:
                  <span className='pl-4'>
                    {`${group.startHole.value || ''} ${group.playersGroup.value || ''}`}
                  </span>
                </p>
              </div>
              {group.users?.filter(Boolean).map((student) => (
                <div
                  className={classNames('d-flex align-items-center px-1', classes.studentWrapper)}
                  key={student.id}
                >
                  <MiniDivisionBadge fill={levelColors[student.level]} className={classes.levelBadge}/>
                  <div className={classes.studentLevel} style={{ color: levelColors[student.level] }}>{student.level}</div>
                  <p className={classes.studentName}>
                    {student.firstName} {student.lastName}
                  </p>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

    </div>
  )
}

export default CartSigns
